<template>
	<div>
		<div class="d-sm-flex align-items-center justify-content-between mb-4">
	        <h1 class="h3 mb-0 text-gray-800">Configurações</h1>
	    </div>

	    <alert ref="alert" />

		<ul class="nav nav-tabs" role="tablist" style="margin-bottom: 5px;">
	        <li class="nav-item">
	        	<router-link :to="{name: 'confSystem', params: {get: 'Sistema'} }" class="nav-link active" data-toggle="tab">Sistema</router-link>
	        </li>
<!--
	        <li class="nav-item">
	        	<router-link :to="{name: 'confPabx', params: {get: 'PABX'} }" class="nav-link" data-toggle="tab">PABX</router-link>
	        </li>
-->
	        <li class="nav-item">
	        	<router-link :to="{name: 'confRel', params: {get: 'Relatorio'} }" class="nav-link" data-toggle="tab">Relatório</router-link>
	        </li>
	    </ul>

	    <div class="row">
	        <div class="col-12">
	            <div class="tab-content">
	            	<transition mode="out-in" name="leftIn">
						<router-view :key="get" @alert="show_alert"></router-view>
					</transition>
	            </div>
	        </div>
	    </div>
	</div>
</template>

<script>
	import alert from "@/components/Tools/alert.vue"

	export default {
		props: ["get"],
		components: { alert },

		data() { return {
			alert: { type: "", msg: "",active: true},
		}},

		beforeRouteUpdate(to, from, next) {
			next();
		},

		created() {
			$("*#app-alert").show()
		},

		methods: {
			show_alert(payload) {
				if ( payload.status == "success") this.$refs.alert.alert('Dados salvos com sucesso!', 'alert-success')
				else this.$refs.alert.alert('Problemas ao salvar dados!', 'alert-danger')
				/*
				this.alert.type = (payload.status == "success") ? "alert-success" : "alert-danger"
				this.alert.msg  = payload.result
				this.alert.active  = true

				$("*#app-alert").show()
				setTimeout(() => $("#app-alert").hide(), 3000 )
				*/
			}
		}
	};
</script>

<style>
</style>